/**
 * Object describing how feed items are filtered in the view.
 */
export enum FilterType {
    NEWEST = 'newest',
    UNREAD = 'unread',
    STARRED = 'starred',
}
